import React, { PureComponent } from 'react';
import classnames from 'classnames';
import './toggle.scss';

export class ToggleSimpleField extends PureComponent {
  state = {
    isChecked: '',
  };

  componentDidMount() {
    if (
      typeof this.props.value === 'boolean' &&
      this.state.isChecked !== this.props.value
    ) {
      this.setState({ isChecked: this.props.value });
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      typeof this.props.value === 'boolean' &&
      this.state.isChecked !== this.props.value
    ) {
      this.setState({ isChecked: this.props.value });
    }
  }

  handleChange = (e) => {
    const value = e.target.checked;
    this.setState({ isChecked: value });
    this.props.onChange(value);
  };

  render() {
    const { name } = this.props;
    const { isChecked } = this.state;

    return (
      <label className={classnames('toggle', { _on: isChecked })}>
        <input
          type="checkbox"
          name={name}
          id={name}
          onChange={this.handleChange}
          checked={isChecked}
        />
        <div className="toggle__slider" />
      </label>
    );
  }
}
